import type { LangCode } from "./meeting.ts";

export interface LangMeta {
  code: LangCode;
  label: string;
  labelEn: string;
  bcp47: string;
  rtl: boolean;
  flag: string;
}

export const LANGUAGES: LangMeta[] = [
  { code: "en", label: "English", labelEn: "English", bcp47: "en-US", rtl: false, flag: "EN" },
  { code: "he", label: "עברית", labelEn: "Hebrew", bcp47: "iw-IL", rtl: true, flag: "עב" },
  { code: "fr", label: "Français", labelEn: "French", bcp47: "fr-FR", rtl: false, flag: "FR" },
  { code: "es", label: "Español", labelEn: "Spanish", bcp47: "es-ES", rtl: false, flag: "ES" },
  { code: "de", label: "Deutsch", labelEn: "German", bcp47: "de-DE", rtl: false, flag: "DE" },
  { code: "ar", label: "العربية", labelEn: "Arabic", bcp47: "ar-SA", rtl: true, flag: "عر" },
  { code: "pt", label: "Português", labelEn: "Portuguese", bcp47: "pt-BR", rtl: false, flag: "PT" },
  { code: "ja", label: "日本語", labelEn: "Japanese", bcp47: "ja-JP", rtl: false, flag: "JA" },
  { code: "ko", label: "한국어", labelEn: "Korean", bcp47: "ko-KR", rtl: false, flag: "KO" },
  { code: "zh", label: "中文", labelEn: "Chinese", bcp47: "zh-CN", rtl: false, flag: "中" },
  { code: "it", label: "Italiano", labelEn: "Italian", bcp47: "it-IT", rtl: false, flag: "IT" },
  { code: "nl", label: "Nederlands", labelEn: "Dutch", bcp47: "nl-NL", rtl: false, flag: "NL" },
  { code: "ru", label: "Русский", labelEn: "Russian", bcp47: "ru-RU", rtl: false, flag: "RU" },
  { code: "tr", label: "Türkçe", labelEn: "Turkish", bcp47: "tr-TR", rtl: false, flag: "TR" },
  { code: "hi", label: "हिन्दी", labelEn: "Hindi", bcp47: "hi-IN", rtl: false, flag: "HI" },
];

export function langMeta(code: string): LangMeta {
  return LANGUAGES.find((l) => l.code === code) ?? LANGUAGES[0]!;
}

export function bcp47ToLangCode(bcp47: string): LangCode {
  const prefix = bcp47.split("-")[0]!.toLowerCase();
  if (prefix === "iw") return "he";
  const match = LANGUAGES.find((l) => l.bcp47.toLowerCase().startsWith(prefix));
  return match?.code ?? "en";
}

/**
 * Normalize a stored user-settings language (which may be region-suffixed, e.g.
 * `pt-BR` / `zh-CN`) to a canonical short `LangCode` (`pt` / `zh`). Falls back to
 * English for anything unrecognized.
 */
export function userLangToLangCode(userLang: string): LangCode {
  const short = userLang.split("-")[0]!.toLowerCase();
  if (short === "iw") return "he";
  return LANGUAGES.find((l) => l.code === short)?.code ?? "en";
}
